<template>
  <v-container class="flags list component">
    <can I="list" a="Flag">
      <!-- Table -->
      <v-data-table
        @update:pagination="event => $emit('paginate', event)"
        :rows-per-page-items="[25, 100, 500]"
        :pagination.sync="pagination"
        :total-items="total"
        :headers="headers"
        :items="flags"
        class="elevation-0"
      >
        <template slot="items" slot-scope="{ item: flag }">
          <td>{{ flag.id }}</td>
          <td>
            <router-link v-if="flag.profile" :to="`/profiles/${flag.profile.id}`">
              {{ flag.profile.fullName }}
            </router-link>
          </td>
          <td>
            <v-tooltip right color="grey darken-3">
              <span slot="activator">
                {{ flag.target || flag.targetType }}
              </span>
              <span>{{ flag.tooltip }}</span>
            </v-tooltip>
          </td>
          <td>
            <Flag icon :value="flag" />
          </td>
          <td>
            <router-link v-if="flag.initiator" :to="`/clients/${flag.initiator.id}`">
              {{ flag.initiator.fullName }}
            </router-link>
          </td>
          <td>
            <v-tooltip left color="grey darken-3">
              <span slot="activator">
                {{ new Date(flag.createdAt) | inWords({ addSuffix: true }) }}
              </span>
              <span>{{ new Date(flag.createdAt) | date('MM/dd/yyyy (HH:mm)') }}</span>
            </v-tooltip>
          </td>
          <td>
            <v-tooltip left v-if="flag.resolvedAt" color="grey darken-3">
              <span slot="activator">
                {{ new Date(flag.resolvedAt) | inWords({ addSuffix: true }) }}
              </span>
              <span>{{ new Date(flag.resolvedAt) | date('MM/dd/yyyy (HH:mm)') }}</span>
            </v-tooltip>
            <span v-else><v-icon left small>mdi-alert</v-icon> Unresolved</span>
          </td>
          <td>
            <can I="delete" a="Flag">
              <v-menu v-if="flag.id" max-width="400" left>
                <v-btn small flat fab slot="activator" color="error">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>

                <v-card>
                  <v-card-title class="subheading">
                    You are about to delete the below flag.
                  </v-card-title>
                  <v-card-text>
                    <Flag :value="flag" />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn flat>Cancel</v-btn>
                    <v-btn color="error" @click="destroy(flag)">Destroy</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </can>
          </td>
        </template>
      </v-data-table>
    </can>
  </v-container>
</template>

<script>
// Components
import Flag from '@/components/flags/Flag'

// Data
import flagsData from '@/data/flags'

// Vue Component
export default {
  components: { Flag },

  props: {
    value: { type: Array, required: true },
    total: Number,
  },

  data() {
    return {
      // Table Configuration
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Profile', value: 'profile.fullName' },
        { text: 'Target', value: 'target', sortable: false },
        { text: 'Severe', value: 'isSevere' },
        { text: 'Created by', value: 'initiator.fullName' },
        { text: 'Created at', value: 'createdAt' },
        { text: 'Resolved at', value: 'resolvedAt' },
        { text: '', sortable: false },
      ],
      pagination: { sortBy: 'createdAt', descending: true, rowsPerPage: 25 },
    }
  },

  computed: {
    flags() {
      if (!this.value || !this.value[0]) return []

      const flags = JSON.parse(JSON.stringify(this.value))

      return flags.map(f => {
        let flagData = flagsData.find(d => d.key === f.key) || {}
        return { ...f, ...flagData }
      })
    },
  },
  methods: {
    destroy(flag) {
      this.$store.dispatch('admin/flags/destroy', flag)
      .then(
        response => {
          this.$store.dispatch('snackbarSuccess', 'Deleted')
          this.$emit('refresh')
        },
        response => {
          this.$store.dispatch('snackbarError', 'Delete Failed')
        }
      )
    },
  },
}
</script>
